export default __webpack_public_path__ + "static/media/icon_5.fca73943.png";